import { render, staticRenderFns } from "./AddSuppliers.vue?vue&type=template&id=2ee4cde5&scoped=true&"
import script from "./AddSuppliers.vue?vue&type=script&lang=js&"
export * from "./AddSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./AddSuppliers.vue?vue&type=style&index=0&id=2ee4cde5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee4cde5",
  null
  
)

export default component.exports